<template>
  <div>
    <Subtitle v-bind:ServiceID="this.AppServiceID">
      <template v-slot:header>
        <i class="fas fa-syringe"></i><b>Manage Vaccine Requests:</b>
      </template>
    </Subtitle> 

      <b-modal id="modal-sm" size="md" v-model="loading" no-close-on-esc no-close-on-backdrop hide-header-close hide-footer>
        <div slot="default">
        <div class='alert alert-danger' role='alert' > Searching vaccine requests data , please wait.... <br>  </div>

        <!-- Auth :{{IsAuth}} -->
        <!-- <bar-loader class="custom-class" :color="color" :loading="loading" :size="size" :sizeUnit="unit"></bar-loader>  -->
        <div class="text-center justify-content-center row col-12">
            <ring-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Ringsize" :sizeUnit="unit"></ring-loader> 
            <rise-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Risesize" :sizeUnit="unit"></rise-loader> 
            <ring-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Ringsize" :sizeUnit="unit"></ring-loader> 
          
        </div>          
        <!-- <div class='alert alert-danger' role='alert' > Your session has expired. please Login again to restore your session. <br>  </div> -->
        </div>  
    </b-modal>
    <b-modal
      id="phModal"
      modal-class="test-modal fade"
      v-model="ShowModel"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      ok-variant
      cancel-variant
      hide-footer
      header-class="PopUpHeader"
      :body-bg-variant="PopUpVar.bodyBgVariant"
      :body-text-variant="PopUpVar.bodyTextVariant"
      :footer-bg-variant="PopUpVar.footerBgVariant"
      :footer-text-variant="PopUpVar.footerTextVariant"
    >
      <template slot="modal-header">
        <div style="margin: 0 auto">
          <small class="PopUpTitle w-100 text-center"> {{ popupTitle }}</small>
        </div>
      </template>
    </b-modal>
    <form class="card p-0 mb-1" id="SearchForm">
      <div class="row">
        <div class="col-8">
          <div class="card">
            <div
              class="card-header d-flex align-items-center"
              style="height: 2rem; text-align: left"
            >
              <h5>
                <small class="text-muted"
                  ><b
                    ><i class="fas fa-search-plus"></i>Search: Pharmacy Request</b
                  ></small
                >
              </h5>
            </div>
            <div class="form-row p-2">
              <div class="form-group col-sm-2">
                <label for="inputPassword4" class="label-small"
                  >Cut-off Date:</label
                >
                <div>
                  <datepicker
                    class="servdatapick"
                    :typeable="typable"
                    :open-date="new Date()"
                    v-model="cDate"
                    :format="DateFormat"
                    id="toDate"
                    :bootstrap-styling="true"
                    :input-class="datapickClass"
                    name="toDatepicker"
                    :disabledDates="{
                    days: [0, 1, 3, 4, 5, 6]                     
                  }"
                  ></datepicker>
                </div>
                <div  class="row" v-show="$v.cDate.$error">
                <div class="col-sm-12"> 
                  <small class="sml-red" v-if="!$v.cDate.require">Cut-off Date	is required.</small>
                </div>  
              </div>
              </div>
              <div class="form-group col-sm-6">
                <label for="inputEmail4" class="label-small">Search Community and Covid Zones:</label>
                <div class="">
                    <vue-bootstrap-typeahead
                    :inputClass="TypeHeadClass"
                    id="clinicSel"
                    ref="zoneRef"
                    @input="CovidZonetextChanged"
                    v-model="SelectedCovidZone"
                    :data="CovidZones"
                    @hit="
                      selectedZone = $event;
                      searched = false;
                    "
                    :serializer="(item) =>item.community +'-'+item.zone" 
                    textVariant=".text-primary"
                    placeholder="Search Community and Covid Zones"
                    size="sm"
                    backgroundVariant="bg-light"
                    :maxMatches="20"
                    updateOn="blur"
                  >
                    <template slot="prepend">
                      <span
                        class="input-group-text form-control-xs"
                        style="font-size: 0.7rem"
                        ><i class="fas fa-search fa-sm"></i
                      ></span>
                    </template>
                  </vue-bootstrap-typeahead>
                </div>
              </div>
          
             <div class="form-group col-sm-2">
                <label for="inputPassword4" class="label-small"
                  >Dosage Qty:
                </label>
                <div class="">
                <input
                onkeydown="javascript: return event.keyCode === 8 ||
                event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                type="number"
                min="1"
                max="300"
                v-model="selectedQty"/>
                  <!-- <select
                    id="override"
                    v-model="selectedQty"
                    class="form-control form-control-xs select-css"
                  >
                    <option
                      v-for="option in qty"
                      v-bind:value="option.id"
                      :key="option.id"
                    >
                      <strong>{{ option.text }} </strong>
                    </option>
                  </select> -->
                </div>
                  <div class="row" v-show="$v.selectedQty.$error">
                  
                  <div class="col-sm-12">
                    <small class="sml-red" v-if="!$v.selectedQty.val"
                      >invalid Qty.</small
                    >
                    <!-- <small class="sml-red" v-if="!$v.selectedQty.maxLength"
                      >invalid Qty.</small
                    > -->
                  </div>
                </div>
              </div>

              <div class="form-group col-sm-2">
                <label for="inputPassword4" class="label-small">  </label>
                        <div class="">
                        <button  type="button" class="btn btn-primary btn-sml mt-1" @click="PharmacyRequest"> Search </button>
                      </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4 pl-0">
          <div class="card">
            <div
              class="card-header d-flex align-items-center pl-1"
              style="height: 2rem; text-align: left"
            >
              <h5>
                <small class="text-muted"
                  ><b
                    ><i class="fas fa-clinic-medical"></i>DownLoad : Batch Pharmacy Requests</b
                  ></small
                >
              </h5>
            </div>
            <div class="form-group row">
               <div class="col-sm-10  d-flex align-items-center justify-content-center mt-auto" style="text-align: bottom">
                 <button v-on:click="DownloadRequestFile" type="button" class=" mt-5 mb-0 btn btn-primary btn-sml mt-1" :class="btnclass"> Download Request File </button>
               </div>
 
            </div>
 
          </div> 
        </div>
      </div>
    </form> 

 <div id="Req" class="mt-2" v-if="requests.length">
  <form class="card p-1 mb-1" id="Req"> 
    <v-client-table
      class="mt-2"
      :columns="columns"
      :data="requests"
      :options="options"
    >
    <div slot="afterFilter"  class="VueTables_Adduser  mr-3 mt-3 ml-3"> 
    <download-excel
      class="pointer"
      :data="requests"
      type="csv"   
      name    = "PharmacyRequests.csv"
      :fields = "{ 'pharmacyno': 'pharmacyno',
        'pharmacy': 'pharmacy',
        'cutoffdate': 'cutoffdate',
        'product': 'product', 
        'doseqty': 'doseqty',
        'requestweek': 'requestweek', 
        'zone': 'zone',
        'community': 'community',}" 
    > 
      <span class="text-muted pointer fas fa-cloud-download-alt text-muted  fa-lg mt-2" ></span><b class="text-muted ml-2">Download Csv</b>
  </download-excel> 
   </div> 
    </v-client-table>
        </form>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import LayoutDefault from "@/Common/Default/DefaultLayout.vue";
import Subtitle from "@/Common/Default/SubTitle.vue";
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import { PopUpVariant } from "@/Common/Default/PopUpVariant";
import { isNullOrUndefined } from "util";
import Datepicker from "vuejs-datepicker";
import Vuelidate from "vuelidate";
import { helpers } from "vuelidate/lib/validators";
import AddRequest from "@/components/Covid/AddRequest.vue";
import EditRequest from "@/components/Covid/EditRequest.vue";
import JsonExcel from 'vue-json-excel'; 
import { RingLoader } from "@saeris/vue-spinners";
import { RiseLoader } from "@saeris/vue-spinners";
Vue.component('downloadExcel', JsonExcel)
import {
  required,
  minLength,
  maxLength,
  between,
  withParams,
  numeric,
} from "vuelidate/lib/validators";
const alphaNum = helpers.regex("alphaNum", /^\d{1,5}\s\w*/);
Vue.use(Vuelidate);
export default {
  props: { LeadAssessor: false, ServiceID: "" },
  data: function () {
    return {
      loading: false,
      size: 150,
      Ringsize: 30,
      Risesize: 12,
      margin: "2px",
      unit: "px",
      color: "#bada55",
      selectedQty:'',
      qty:[],
      SelectedCovidZone: "",
      selectedZone: '',
      TypeHeadClass: "form-control form-control-xs my-0",
      cDate:'',
      typable:false,
      RequestFileExist:false, 
      CovidZone: "",
      CovidZones: [],
      TypeHeadinptClass: "form-control form-control-xs my-0",
      fromDate: "",
      toDate: "",
      serviceDate: "",
      DateFormat: "",
      datapickClass: "form-control form-control-xs my-0",
      Comments :'',
      
      showSubmit: false,
      datePassed: "", 
      HeaderId: "",
      clinic: [],
      popupTitle: "",
      ShowAdd: false,
      ShowEdit: false,
      ShowModel: false,
      AddEdit: "A",
      ClinicNo: "",
      clientdata: "",
      TypeHeadinptClass: "form-control",
      ShowFacilities: false,
      Facilities: "",
      SelectedFacility: "",
      SelectFacId: "",
      Patient: "",
      Risks: "",
      RisFactors: "",
      datapickClass: "form-control form-control-xs my-0",
      PopUpVar: PopUpVariant,
      effectiveDate: "",
      HSN: "",
      ProviderNo: "",
      Showinfo: false,
      showError: false,
      MsgPopup: false,
      showModal: false,
      requests: [],
      requestDetail: [], 
      columns: ["pharmacyno","pharmacy","product" ,"doseqty","requestweek","zone","community"],
      options: {
        texts: {
          count: "",
          first: "First",
          last: "Name",
          filter: "Filter Request Data:",
          filterPlaceholder: "Search Requests",
          limit: "Records:",
          page: "Page:",
          noResults: "Vaccine request not found.",
          filterBy: "Filter by {column}",
          loading: "Loading...",
          defaultOption: "Select {column}",
          columns: "Columns",
        },

        responseAdapter({ data }) {
          return {
            data: formatData,
            count: data.length,
          };
        },
        footerHeadings: false,
        perPage: 10,
        perPageValues: [10,20,40,80,100],
        toMomentFormat: "YYYY-MM-DD",
        templates: {
          cutoffdate(h, row) {
            return moment(row.cutoffdate, "YYYY-MM-DD").format("YYYY/MM/DD");
          }, 
          requestweek(h, row) {
            return moment(row.requestweek, "YYYY-MM-DD").format("YYYY/MM/DD");
          }, 
        },

        headings: {
          pharmacyno: "Pharmacy No",
          // cutoffdate: "Cut-off Date",
          product : "Product", 
          pharmacy: "Pharmacy Name", 
          doseqty: "Dosage Qty",
          requestweek: "Request Week",
          zone: "Zone",
          community : "Community"
        },
        sortable: ["pharmacyno","pharmacy","product" ,"doseqty","zone","community","requestweek" ],
        filterable: ["pharmacyno","pharmacy","product" ,"doseqty","zone","community"],
        sortIcon: {
          base: "fas",
          is: "fa-sort",
          up: "fa-sort-up",
          down: "fa-sort-down",
        },
      },
    };
  },
  watch: {},
  components: {
        RingLoader,
    RiseLoader,
    Card,
    CardBody,
    TileNote,
    Datepicker,
    Subtitle,
    AddRequest,
    EditRequest,
  },
  filters: {
    moment: function (date) {
      return moment(date, "YYYY-MM-DD").format("YYYY/MM/DD");
    },
    stringify(value) {
      return JSON.stringify(value, null, 2);
    },
  },
  computed: {
    UserName() {
      return !this.$store.getters.GetCurrentUser
        ? false
        : this.$store.getters.GetCurrentUser;
    },
    btnclass() {
      if(this.RequestFileExist)
      {
        return "btn btn-primary btn-sml mt-1"
      }
      else 
        return "btn btn-outline-primary btn-sml mt-1"
      //return darkMode ? 'dark-theme' : 'light-theme';
    }
  },
  methods: {
       GetQty() {
      var vm = this;
      vm.qty = [];
       var params = new URLSearchParams();
       params.append("name", "REQ");
      axios
        .get("SaskHealthApi/Codes/GetLookups", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) { 
          vm.qty = response.data; 
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        })
        .then(function () {
          // vm.qty.unshift({id :'-1', text :'Select qty' , sort :4});
          // vm.selectedQty = -1;
        });
    },
    CovidZonetextChanged() {
      if (this.SelectedCovidZone == "" || this.SelectedCovidZone == null) {
        this.selectedZone = null;
      }
    },
      GetCovidZones() {
      var vm = this;
      vm.CovidZones = [];
      // var params = new URLSearchParams();
      // //console.log("username " + vm.UserName);
      // params.append("username", vm.UserName);
      axios
        .get("SaskHealthApi/Codes/GetCovidZones", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          //params,
        })
        .then(function (response) {
          ////console.log(response.data);
          vm.CovidZones = response.data;
          //vm.ClinicNo = vm.clinic[0].clinicno;
          ////console.log("clinic no " + vm.ClinicNo);
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        })
        .then(function () {
          //vm.PharmacyAllocation();
        });
    },
    GetRequestFileExist() {
      var vm = this;
      axios
        .get("SaskHealthApi/Codes/GetRequestFileExist", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          //params,
        })
        .then(function (response) {
          //console.log(response.data);
          if(response.data =="TRUE")
          {
            vm.RequestFileExist =true;
          } 
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        })
        .then(function () {});
    },
    DownloadRequestFile: function () {
      var vm = this;
      var url = "/SaskHealthApi/Codes/GetRequestFile?_=";
      axios
        .get(url + Date.now(), {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          //  params,
        })
        .then(function (response) {
          //vm.forceFileDownload(response);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "VaxRequest.csv"); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(function (er) {
          if (er.status == 404) {
          //console.log('at 404');
          vm.showMsg(
              "File not found, please contact system admin for more detail.",
              "",
              "Request File Error"
            );
          } 
          else if (er.status == 400) {
          vm.showMsg(
              "File not found, please contact system admin for more detail.",
              "",
              "Request File Error"
            );
          }          
          else if (er.status == 500) {
              vm.showMsg(
              "Network Error: Please contact system admin for more detail.",
              "",
              "Request File Error"
            );
          }
          //console.log(er);
        });
    },
    IsCutoffDatePassed(cDate) {
      var vm = this;
      var params = new URLSearchParams();
      params.append("Cutoffdate", cDate);
      axios
        .get("SaskHealthApi/Codes/GetIsCutoffPassed", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          vm.datePassed = response.data;
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        })
        .then(function () {
         // vm.PharmacyRequest();
        });
    },
    CloseDetailModal() {
      this.PharmacyRequest();
      this.ShowModel = false;
    },
    GetClinicInfo() {
      var vm = this;
      var params = new URLSearchParams();
      ////console.log("username " + vm.UserName);
      params.append("username", vm.UserName);
      axios
        .get("SaskHealthApi/Codes/GetClinicinfo", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          ////console.log(response.data);
          vm.clinic = response.data;
          vm.ClinicNo = vm.clinic[0].clinicno;
          ////console.log("clinic no " + vm.ClinicNo);
        })
        .catch(function (er) {
          if (er.status == 400) {
          } else if (er.status == 500) {
          }
        })
        .then(function () {
          //vm.PharmacyRequest();
        });
    },
    AddEditPopup(row, action) {  
    },
 
    PharmacyRequest() {
      var vm = this;
      
      vm.requests = [];
      vm.$v.$touch();
      if (!vm.$v.$invalid) {
        vm.loading=true;
      var params = new URLSearchParams();
      var cuttoff = moment(vm.cDate, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
      );
      params.append("cuttoffDate", cuttoff);
      params.append("qtyReq", vm.selectedQty);
      if (
      vm.selectedZone == "" ||
      vm.selectedZone == null ||
      vm.selectedZone == undefined
      ) {
      params.append("CovidZoneID", "0");

      } else {
      params.append("CovidZoneID", vm.selectedZone.id);

      }  
    
      ////console.log(vm.cDate);
      axios
        .get("SaskHealthApi/Codes/GetAllPharmacyRequests", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          ////console.log(response.data);
          vm.requests = response.data;
        })
        .catch(function (er) {
             if (er.status == 500) {
              vm.showMsg(
                "Error while processing your request, please contact system admin.",
                "",
                "Request Confirmation"
              );
            } else if (er.status == 400) {
              vm.showMsg(
                "Error while processing your request, please contact system admin.",
                "",
                "Request Confirmation"
          );}
        }).then(function () {
            vm.loading=false;
            if(vm.requests.length==0)
            {
              vm.showMsg("Vaccine Request not found.", "", "Request Confirmation"); 
            }
          });
      }
    },

    Show() {
      this.Showinfo = true;
    },
    ClosePopup() {
      this.showError = false;
    },
    validateQty(){
        if(this.selectedQty != null || this.selectedQty !="" || this.selectedQty != undefined)
        {
          ////console.log('here not null')
          if(this.selectedQty >=0)
          {
            ////console.log(' > 0')
            return true;
          }
          else
          {
            ////console.log(' < less 0')
              return false;
          }
        }
        else
        {
          if(!isNaN(this.selectedQty))
          {
            return false;
          }
          else
          return true;
        }
        
    },
    showMsg(msg, data, Title) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
  },
  created: function () {
    this.$emit("update:layout", LayoutDefault);
    this.AppServiceID = this.$store.getters.GetDPEBBServiceID;
    this.DateFormat = this.$store.getters.GetDateFormat;
    this.ServiceDate = moment(new Date()).format("YYYY/MM/DD");
    this.GetClinicInfo();
     this.GetCovidZones();
    this.GetRequestFileExist();
    //this.GetQty();
  },
  beforeCreate: function () {
    this.$store.dispatch("AddServiceID", this.$store.getters.GetDPEBBServiceID);
    this.$store.dispatch("GetMenuItems", this.$store.getters.GetDPEBBServiceID);
  },
  mounted: function () {
    //this.$refs.SearchClinic.inputValue = 'Some value'
    this.$nextTick(function () {});
  },

  validations() {
    return {
      cDate:{
          required,
      },
      selectedQty : {
         maxLength: 4,
         val: (value) => this.validateQty(),
      },
    };
  },
};
</script>
<style scopped>
.ulClass {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0px !important;
}
.liClass {
  border: 1px solid;
  margin-bottom: 5px;
  border-radius: 5px;
  margin-right: 5px;
  padding: 0 5px;
}
.file-name {
  min-width: 150px;
  font-size: 13px;
}
.uploaded-date {
  font-size: 12px;
}
.upload-progress {
  font-size: 12px;
}
.file-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0px !important;
}
.file-details {
  margin-bottom: 0px !important;
}

.row.no-gutter [class*="col-"] {
  padding-right: 1px;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 0px 15px;
  margin-bottom: -1px;
  border: 1px solid #ddd;
  background-color: blue;
  line-height: 1em;
}
/* remove right padding from first column */
/* .row.no-gutter [class*='col-']:first-child {
  padding-right:5px;
} */
/* remove left padding from first column */
/* .row.no-gutter [class*='col-']:last-child {
  padding-left:5px;
} */

/* only for column content visible */
.col-lg-1 > div {
  background-color: #ddd;
}

#docimg {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 10px; */
}
#line {
  border-top: 1px solid rgba(7, 14, 109, 0.25);
  /* border-bottom:1px solid #c00;
  border-bottom: 1px solid rgba(255,255,255,.25); */
}
.select-css {
  display: block;
  font-size: 14px;
  /* font-family: sans-serif; */
  font-weight: 600;
  color: #444;
  line-height: 1.3;
  padding: 0.6em 1.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.5em;
  -moz-appearance: none;
  -webkit-appearance: none;
  /* appearance: none; */
  background-color: #fff;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E"),
    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}
.select-css::-ms-expand {
  display: none;
}
.select-css:hover {
  border-color: #888;
}
.select-css:focus {
  border-color: #aaa;
  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
  box-shadow: 0 0 0 3px -moz-mac-focusring;
  color: #222;
  outline: none;
}
.select-css option {
  font-weight: normal;
}
#ServiceCodeGrid .VuePagination__count {
  visibility: hidden;
  height: 0px;
}
#ServiceCodeGrid .pagination {
  height: 0px;
}
/* #ServiceCodeGrid tr td:nth-child(2) {
    width: 9.5rem !important;
    padding:3px !important;
    /* margin:0rem !important;
}  */

.highlight {
  background-color: #fff2ac;
  background-image: linear-gradient(to right, #ffe359 0%, #fff2ac 100%);
}
.bd-highlight {
  /* background-color: rgba(86,61,124,0.15); */
  /* border: 1px solid rgba(86,61,124,0.15); */
  background-image: linear-gradient(to right, #ffe359 0%, #fff2ac 100%);
  /* background-image: linear-gradient(to right, #ac9732ad 0%, #cebc5985 100%); */
  /* text-decoration-line: underline; */
  font-weight: bold;
  padding: 0.4rem;
  margin: 0rem !important;
}

.cov {
  font-size: 1.3rem;
  font-weight: bolder;
  /* padding: .2rem; */
  margin: 0rem !important;
}

.test-modal .modal {
  padding: 0 !important;
  padding-left: 0px !important;
  overflow-y: scroll;
}

.test-modal .modal-dialog {
  max-width: 100%;
  height: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 100000;
  padding-right: 0px !important;
  padding-left: 0px !important;
}

.modal-open {
  padding: 0 !important;
  padding-left: 0px !important;
  overflow-y: scroll;
}

#phModal {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>